import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class PatientsAtendedDiagnostic {
    exportExcel(data, fecha_inicial, fecha_final) {
        let option = {};  // La opción representa el archivo de Excel
        let patientsSeenDiagnostic = this.patientsSeenDiagnostic(data, fecha_inicial, fecha_final);
        option.fileName = 'Pacientes Atendidos por Diagnostico';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: patientsSeenDiagnostic.data,  // Fuente de datos en archivo Excel
                sheetName: 'Pacientes Atendidos',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    patientsSeenDiagnostic(patientsAtended, fecha_inicial, fecha_final) {
        let diagnostico_paciente = patientsAtended;
        let dataTable = [];  // Contenido de datos en archivo Excel
        let Casillas = this.generarCasillas();//Casillas Vacias y Preconfiguradas

        dataTable.push(Casillas);

        let tituloNombreEmpresa = this.generarTituloPerfil();//Titulo Nombre de Empresa
        let titulosCierreCaja = this.generarTituloConVacios();//Titulos del Recibo de Caja
        let tituloFechaInicial = this.generarTituloFechaInicial(fecha_inicial);
        let tituloFechaFinal = this.generarTituloFechaFinal(fecha_final);

        dataTable.push(tituloNombreEmpresa);
        dataTable.push(titulosCierreCaja);
        dataTable.push(tituloFechaInicial);
        dataTable.push(tituloFechaFinal);
        dataTable.push(Casillas);

        //Generacion de Pacientes Atendidos en el Excel
        if (diagnostico_paciente.length > 0) {
            let Titulos = this.generarTituloPaciente();//Titulos del Recibo de Caja
            dataTable.push(Titulos);

            for (let i in diagnostico_paciente) {  // Ciclo de obtener los datos de cada fila en Excel
                let obj = this.generarDatosPaciente(diagnostico_paciente[i]);
                dataTable.push(obj);  // Establecer la fuente de datos obtenida por cada columna en Excel
            }

            dataTable.push(Casillas);
        }

        let sheet =
        {
            data: dataTable
        }
        return sheet;
    }

    generarCasillas() {
        let casillas = {
            '1': "",
            '2': "",
            '3': "",
            '4': "",
            '5': "",
            '6': "",
            '7': "",
            '8': "",
            '9': "",
            '10': "",
        }
        return casillas;
    }

    generarTituloPerfil() {
        let perfil = sessionStorage.getItem('perfil');
        let Titulos = {
            '1': 'Nombre de Empresa',
            '2': sessionStorage.getItem('nombre_empresa'),
        }
        return Titulos;
    }

    generarTituloConVacios() {
        let Titulos = {
            '1': 'Tipo de Reporte',
            '2': "Reporte de Pacientes Atendidos por Diagnostico",
        }
        return Titulos;
    }

    generarTituloFechaInicial(fecha_inicial) {
        let Titulos = {
            '1': 'Fecha Inicial',
            '2': moment(fecha_inicial).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generarTituloFechaFinal(fecha_final) {
        let Titulos = {
            '1': 'Fecha Final',
            '2': moment(fecha_final).format('MMMM Do YYYY'),
        }
        return Titulos;
    }

    generarTituloPaciente() {
        let Titulos = {
            '1': "Identificación",
            '2': "Nombre del Paciente",
            '3': "Genero",
            '4': "Fecha de Nacimiento",
            '5': "Edad",
            '6': "Dirección",
            '7': "Cel-Tel",
            '8': "Email",
            '9': "Diagnostico",
            '10': "Nombre del Profesional"
        }
        return Titulos;
    }

    generarDatosPaciente(paciente) {

        let diagnosticoText = "";
        for (let k = 0; k < paciente.diagnostico.diagnostico.length; k++) {
            if (k == 0) {
                diagnosticoText = paciente.diagnostico.diagnostico[k].codigo + '-' + paciente.diagnostico.diagnostico[k].nombre;
            }
            else {
                diagnosticoText = diagnosticoText + ", " + paciente.diagnostico.diagnostico[k].codigo + '-' + paciente.diagnostico.diagnostico[k].nombre;
            }
        }

        let numerTelephone = !!paciente.celular ? !!paciente.telefono ? paciente.celular + " - " + paciente.telefono : paciente.celular : !!paciente.telefono ? paciente.telefono : "";

        let recibo = {
            '1': paciente.tip_documento + " - " + paciente.num_documento,
            '2': paciente.nombre_paciente,
            '3': paciente.sexo,
            '4': moment(new Date(paciente.fec_nacimiento)).format('YYYY/MM/DD'),
            '5': paciente.edad,
            '6': paciente.direccion.replace('"\"', '').replace('\""', ""),
            '7': numerTelephone,
            '8': paciente.correo,
            '9': diagnosticoText,       //diagnostico_concat,
            '10': paciente.nombre_profesional,
        }
        return recibo;
    }

}

export default new PatientsAtendedDiagnostic();